module.exports = __webpack_public_path__ + "static/img/8.3fa11d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/8.png
// module id = 1s+O
// module chunks = 0